export const BUCKETS = {
    bucketAssets: 'medicommerce-assets'
};
